module.exports = __webpack_public_path__ + "img/mini.4ae734fb.svg";